import React, { useEffect, useRef, useState } from 'react';

const useReveal = (threshold = 0.12) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold }
    );
    const el = ref.current;
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [threshold]);

  return [ref, isVisible];
};

const Footer = () => {
  const [ref, isVisible] = useReveal(0.1);

  return (
    <footer className="bg-white py-16 border-t border-gray-100">
      <div className="container mx-auto px-6">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`}>
          <div className="max-w-4xl">
            <h3
              className="text-3xl md:text-4xl font-bold text-black mb-3"
              style={{ fontFamily: "'DM Serif Display', serif" }}
            >
              Mahadev Printers
            </h3>

            <p className="text-gray-500 italic text-lg mb-8">Prints Your Imaginations</p>

            <a
              href="https://www.google.com/maps/place/250%2F252,+Perin+Nariman+St,+Borabazar+Precinct,+Fort,+Mumbai,+Maharashtra+400001/@18.9348781,72.8355554,17z/data=!3m1!4b1!4m6!3m5!1s0x3be7d1dba1612963:0xe1beba1d534ff3d0!8m2!3d18.9348781!4d72.8355554!16s%2Fg%2F11cshtlvvj?entry=ttu&g_ep=EgoyMDI2MDQxMy4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-gray-600 text-base mb-2 hover:underline cursor-pointer"
            >
              250/252 Perin Nariman Street, Fort, Mumbai - 400001
            </a>

            <a
              href="tel:02266100600"
              className="block text-gray-600 text-base mb-2 hover:underline cursor-pointer"
            >
              Tel: 022-66100600
            </a>

            <p className="text-gray-600 text-base">
              Vijay:{' '}
              <a href="tel:+919821149384" className="hover:text-black hover:underline">
                +91 9821149384
              </a>{' '}
              | Arvind:{' '}
              <a href="tel:+919324595111" className="hover:text-black hover:underline">
                +91 9324595111
              </a>
            </p>
          </div>
        </div>

        <div className="text-center mt-16 pt-8 border-t border-gray-100">
          <p className="text-gray-400 text-base italic">
            &copy; 2026 Mahadev Printers. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
